import { TypeCounts } from "@authory-packages/core";
import { theme } from "../../theme/theme";
import { FORMATED_SOURCE_TYPES } from "../../utils/getFormattedSourceTypes";
import { getSourceTypeCountsValues } from "../../utils/getTypeCountsValues";
import { formatNumber } from "../../utils/largeNumberFormatting";
import { V3CheckBox } from "../OptionInput";
import { V3CaptionGrey48 } from "../ReusableStyledComponents/V3CaptionGrey48";
import { VerticalSpacing } from "../VerticalSpacing";
import { STFPanel } from "./SourceTypesFilter.styles";

export interface SourceTypesFiltersProps {
    selectedTypes: string[];
    handleTypeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    typeCounts?: TypeCounts;
    title?: string;
    isManualBulkAdd?: boolean;
}

export const SourceTypesFilters = ({
    selectedTypes,
    handleTypeChange,
    typeCounts,
    title = "Formats",
    isManualBulkAdd = false
}: SourceTypesFiltersProps) => {
    const counts: any = !!typeCounts ? getSourceTypeCountsValues(typeCounts) : undefined;

    return (
        <>
            <VerticalSpacing top={38} bottom={14}>
                <V3CaptionGrey48>
                    <strong>{title}</strong>
                </V3CaptionGrey48>
            </VerticalSpacing>
            {FORMATED_SOURCE_TYPES.map((type, index) => {
                const Icon = type.icon;

                return (
                    <VerticalSpacing
                        key={type.value}
                        bottom={index < FORMATED_SOURCE_TYPES.length - 1 ? 18 : 0}
                        breakpoints={[
                            {
                                screen: theme.v3.layout.sidebarLayout.mobile,
                                marginBottom: index < FORMATED_SOURCE_TYPES.length - 1 ? 18 : isManualBulkAdd ? 5 : 40
                            }
                        ]}
                    >
                        <STFPanel>
                            <div>
                                <V3CheckBox
                                    icon={<Icon />}
                                    label={type.text}
                                    name={type.value}
                                    id={type.value}
                                    onChange={handleTypeChange}
                                    checked={selectedTypes.includes(type.value)}
                                />
                            </div>
                            {!!counts && (
                                <div>
                                    <V3CaptionGrey48>{formatNumber(counts[type.value])}</V3CaptionGrey48>
                                </div>
                            )}
                        </STFPanel>
                    </VerticalSpacing>
                );
            })}
        </>
    );
};
